export default __webpack_public_path__ + "static/media/dinner.d63ea880.svg";